/** Keeps Hub / Scorecard setup / imports aligned on `mt:session.players`. */

export const TABLE_NAME_MAX = 20;
export const MAX_TABLE_PLAYERS = 6;

/** Min two slots (same as Hub); trim length per Scorecard limits */
export function normalizePlayerSlots(players) {
  const src = Array.isArray(players) ? players.map((p) => String(p ?? '').slice(0, TABLE_NAME_MAX)) : [];
  const out = [...src];
  while (out.length < 2) out.push('');
  return out.slice(0, MAX_TABLE_PLAYERS);
}

export function sessionSlotsHaveNames(players) {
  return normalizePlayerSlots(players).some((n) => String(n).trim());
}

/** Non-empty names in slot order (First Player / copy helpers). */
export function rosterStringsFromSessionPlayers(players) {
  return normalizePlayerSlots(players)
    .map((n) => String(n).trim())
    .filter(Boolean);
}
